<template>
<span
    class="inline-flex items-center px-1.5 py-0.5 rounded text-xs border align-middle font-medium"
    :class="action === 'sale'
     ? 'border-' + isCustomColor(textColor) ? 'custom-text' : textColor
     : 'border-200 border-opacity-75'"
>
    <span class="capitalize">
        {{ (!['signup', 'goal'].includes(action.toLowerCase())) ? 'Sale' : action}}
    </span>
</span>
</template>

<script>
import {isCustomColor} from "../../../../helpers/common";

export default {
    name: "ReferralAction",
    props: ['action', 'textColor'],
    methods: {
        isCustomColor
    }
}
</script>
